import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Testimonials({ items }) {
    if (!items || items.length === 0) return null;
    return (
        <section id="reviews" data-testid="testimonials-section" className="relative bg-[color:var(--surface-dark)] text-white py-24 md:py-40 overflow-hidden">
            <div className="absolute inset-0 grid-bg-dark pointer-events-none" />
            <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-[color:var(--brand-blue)]/15 blur-3xl pointer-events-none" />

            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-8 items-end mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-6">
                        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/50">[ Word of Mouth — 04 ]</div>
                        <h2 className="mt-4 font-display text-5xl md:text-7xl font-black tracking-tighter leading-[0.88]">
                            What our<br />clients say.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-6 md:pl-16">
                        <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-md">
                            Every job answered on time, invoiced clearly, and finished with pride. Here&apos;s what Baton Rouge homeowners had to say.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {items.slice(0, 6).map((t, i) => (
                        <motion.blockquote
                            key={t.id || i}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                            className="relative border border-white/10 bg-white/[0.03] backdrop-blur-md p-8 md:p-10 hover:bg-white/[0.06] transition-colors"
                            data-testid={`testimonial-${i}`}
                        >
                            <div className="font-display text-6xl text-[color:var(--brand-blue)] leading-none">&ldquo;</div>
                            <p className="mt-4 text-lg md:text-xl leading-snug font-display tracking-tight text-white">
                                {t.quote}
                            </p>
                            <div className="mt-8 flex items-center justify-between">
                                <div>
                                    <div className="font-display font-bold text-sm text-white">{t.name}</div>
                                    <div className="text-[11px] uppercase tracking-[0.25em] text-white/50 mt-1">{t.location}</div>
                                </div>
                                <div className="flex gap-0.5 text-[color:var(--brand-blue)]">
                                    {Array.from({ length: t.rating || 5 }).map((_, k) => (
                                        <Star key={k} className="h-3.5 w-3.5 fill-current" />
                                    ))}
                                </div>
                            </div>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
}
